import { render, staticRenderFns } from "./LogsGroupByProcessId.vue?vue&type=template&id=61143428"
import script from "./LogsGroupByProcessId.vue?vue&type=script&lang=js"
export * from "./LogsGroupByProcessId.vue?vue&type=script&lang=js"
import style0 from "./LogsGroupByProcessId.vue?vue&type=style&index=0&id=61143428&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports